import { useMemo } from "react";

const weekDays = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

const toYmd = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const ServiceCalendar = ({
  currentMonth,
  slotsByDate,
  selectedDate,
  onSelectDate,
  isDateExcluded, // ← tu le reçois bien
}) => {
  const calendarDays = useMemo(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const days = [];
    const current = new Date(startDate);

    for (let i = 0; i < 42; i++) {
      const dateStr = toYmd(current);

      const excluded = isDateExcluded?.(dateStr) ?? false; // 🔥 LA LIGNE QUI MANQUAIT
      const hasSlots = !!slotsByDate[dateStr]?.length;

      days.push({
        date: new Date(current),
        dateStr,
        day: current.getDate(),
        isToday: dateStr === toYmd(new Date()),
        isCurrentMonth: current.getMonth() === month,
        isSelected: selectedDate === dateStr,
        hasSlots,
        excluded, // 🔥 pour le rendu
      });

      current.setDate(current.getDate() + 1);
    }
    return days;
  }, [currentMonth, slotsByDate, selectedDate, isDateExcluded]);

  return (
    <div className="p-2">
      <div className="grid grid-cols-7 gap-1 mb-1">
        {weekDays.map((day) => (
          <div
            key={day}
            className="text-center text-[10px] font-semibold text-gray-500 py-1"
          >
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {calendarDays.map((day, idx) => (
          <button
            key={idx}
            onClick={() => onSelectDate(day)}
            disabled={!day.hasSlots}
            className={`
              h-8 w-8 mx-auto rounded-full text-[11px] font-medium transition-all relative
          
              ${
                day.isSelected
                  ? "bg-[#FFD76A] text-primary border border-primary shadow-sm scale-105"
                  : ""
              }
              ${
                day.hasSlots
                  ? "bg-primary text-white border border-primary hover:bg-primary/80"
                  : ""
              }
            `}
          >
            {day.day}
            {day.hasSlots && !day.excluded && (
              <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 text-[6px] text-white">
                •
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ServiceCalendar;
